const state = {
  uploadData: [], // 未上传的数据
  localListUse: [], // 处理队列中的数据，包含处理完毕的和等待处理的
  errorList: []
}

const mutations = {
  setUploadData (state, uploadData) {
    state.uploadData = uploadData
  },
  setlocalListUse (state, localListUse) {
    state.localListUse = localListUse
  },
  setErrorList (state, errorList) {
    state.errorList = errorList
  }
}
export default {
  namespaced: true,
  state,
  mutations
}
